import { useEffect, useLayoutEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import Footer from "component/footer/Footer";
import HeaderNavigation from "component/header/HeaderNavigation";
import axios from "axios";
import DisplayType from "utils/displayType";
import Banner from "component/banner/Banner";
import { ContactMenu, NavigationMenu } from "admin/type/type";
import DefaultButton from "admin/component/button/DefaultButton";
import {
  checkEmailForm,
  trnasfromBase64ToObject,
  updateTitle,
} from "utils/commonUtil";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import ModalLayout from "admin/component/modal/ModalLayout";
import PrivacyPolicyCheckBox from "component/agree-checkbox/PrivacyPolicyCheckBox";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useToastContainer } from "react-toastify";
import Spinner from "component/Spinner";
import * as api from "../../api/api";
import ContactTabs from "./components/ContactTabs";
import { ReactComponent as Arrow } from "../../assets/title_arrow.svg";
import ContactInput from "./components/ContactInput";
import ContactTextArea from "./components/ContactTextArea";
import SectorList from "./components/SectorList";
import ContactFileUpload from "./components/ContactFileUpload";
import SuccessApplyModal from "../../component/success-modal/SuccessApplyModal";
import QnaModal from "./components/QnaModal";

import bg from "../../assets/contact_bg.png";

import { ReactComponent as NewLogo } from "../../assets/new_logo.svg";
import { ReactComponent as NewLogoWhite } from "../../assets/new_logo_white.svg";
import { ReactComponent as MNewLogo } from "../../assets/m_new_logo.svg";
import { ReactComponent as MNewLogoWhite } from "../../assets/m_new_logo_white.svg";

const ExternalApply = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useRef<any | undefined>(undefined);
  const mode = DisplayType();
  const { t } = useLanguage();

  const bodyRef = useRef<HTMLDivElement>(null);
  const section1 = useRef<HTMLDivElement>(null);
  const section2 = useRef<HTMLDivElement>(null);
  const section3 = useRef<HTMLDivElement>(null);
  const section4 = useRef<HTMLDivElement>(null);
  const section5 = useRef<HTMLDivElement>(null);
  const section6 = useRef<HTMLDivElement>(null);
  const section7 = useRef<HTMLDivElement>(null);
  const section8 = useRef<HTMLDivElement>(null);

  const [isSuccessApplyModal, updateSuccessApplyModal] =
    useState<boolean>(false);

  const [isProgress, updateProgress] = useState<boolean>(false);

  const [loaded, updateLoaded] = useState<boolean>(false);

  const [ceoNameError, updateCeoNameError] = useState<boolean>(false);
  const [companyNameError, updateCompanyNameError] = useState<boolean>(false);
  const [ceoTelError, updateCeoTelError] = useState<boolean>(false);
  const [ceoEmailError, updateCeoEmailError] = useState<boolean>(false);
  const [descriptionError, updateDescriptionError] = useState<boolean>(false);
  const [problemError, updateProblemError] = useState<boolean>(false);
  const [solutionError, updateSolutionError] = useState<boolean>(false);
  const [pfIndustrialTechError, updatePfIndustrialTechError] =
    useState<boolean>(false);
  const [fileError, updateFileError] = useState<boolean>(false);
  const [checkedError, updateCheckedError] = useState<boolean>(false);

  const [ceoName, updateCeoName] = useState<string>("");
  const [companyName, updateCompanyName] = useState<string>("");
  const [ceoTel, updateCeoTel] = useState<string>("");
  const [ceoEmail, updateCeoEmail] = useState<string>("");
  const [description, updateDescription] = useState<string>("");
  const [problem, updateProblem] = useState<string>("");
  const [solution, updateSolution] = useState<string>("");
  const [file, updateFile] = useState<any | undefined>(undefined);
  const [additionalInformation, updateAdditionalInformation] =
    useState<string>("");
  const [pfIndustrialTech, updatePfIndustrialTech] = useState<
    {
      isMain: boolean;
      acIndustrialTech: {
        acIndustrialTechId: number;
        name: string;
      };
    }[]
  >([]);
  const [checked, updateChecked] = useState<boolean>(false);

  const [validationChecked, updateValidationChekced] = useState(false);

  const initValue = () => {
    updateCeoNameError(false);
    updateCompanyNameError(false);
    updateCeoTelError(false);
    updateCeoEmailError(false);
    updateDescriptionError(false);
    updateProblemError(false);
    updateSolutionError(false);
    updatePfIndustrialTechError(false);
    updateFileError(false);
    updateCheckedError(false);

    updateCeoName("");
    updateCompanyName("");
    updateCeoTel("");
    updateCeoEmail("");
    updateDescription("");
    updateProblem("");
    updateSolution("");
    updateFile(undefined);
    updateAdditionalInformation("");
    updatePfIndustrialTech([]);
    updateChecked(false);
  };

  const validationChecking = () => {
    const isValidCeoName = ceoName.length === 0;
    const isValidCompanyName = companyName.length === 0;
    const isValidCeoTel = ceoTel.length === 0;
    const isValidCeoEmail = ceoEmail.length === 0 || !checkEmailForm(ceoEmail);
    const isValidDescription = description.length === 0;
    const isValidProblem = problem.length === 0;
    const isValidSolution = solution.length === 0;
    const isValidPfIndustrialTech = pfIndustrialTech.length === 0;
    const isValidFile = file === undefined;
    const isValidChecked = !checked;

    updateCeoNameError(isValidCeoName);
    updateCompanyNameError(isValidCompanyName);
    updateCeoTelError(isValidCeoTel);
    updateCeoEmailError(isValidCeoEmail);
    updateDescriptionError(isValidDescription);
    updateProblemError(isValidProblem);
    updateSolutionError(isValidSolution);
    updatePfIndustrialTechError(isValidPfIndustrialTech);
    updateFileError(isValidFile);
    updateCheckedError(isValidChecked);

    updateValidationChekced((prev) => !prev);

    return (
      !isValidCeoName &&
      !isValidCompanyName &&
      !isValidCeoTel &&
      !isValidCeoEmail &&
      !isValidDescription &&
      !isValidProblem &&
      !isValidSolution &&
      !isValidPfIndustrialTech &&
      !isValidFile &&
      !isValidChecked
    );
  };
  const sendPortfolioInfo = async () => {
    try {
      if (validationChecking()) {
        updateProgress(true);
        const formData = new FormData();
        formData.append("file", file);

        const fileUploadResult = await axios.post(
          api.uploadBusinessPlanFile(),
          formData
        );

        // 구글 드라이브 백업은 부가 단계 — 실패해도 본 제출은 계속 진행한다
        let googleDrive;
        try {
          const googleUploadResult = await axios.post(
            api.uploadGoogleBusinessPlanFile(),
            formData
          );
          googleDrive = googleUploadResult.data;
        } catch (googleUploadError) {
          console.error(
            "[external-apply] 구글 드라이브 백업 실패 — 제출은 계속 진행",
            googleUploadError
          );
        }

        if (fileUploadResult.status === 201) {
          const data = {
            ceoName,
            companyName,
            ceoTell: ceoTel,
            ceoEmail,
            description,
            problem,
            solution,
            additionalInformation,
            pfIndustrialTech,
            businessPlanFile: fileUploadResult.data[0],
            googleDrive,
            acChannel: { name: params.current.channelName },
          };

          const result = await axios.post(api.sendApply(), data);
          if (result.status === 201) {
            updateSuccessApplyModal(true);
            updateProgress(false);
            initValue();
          }
        }
      }
    } catch (error) {
      console.error("[external-apply] 지원서 제출 실패", error);
      updateProgress(false);
      alert(t("contact", "external.submitFailed"));
    }
  };

  useEffect(() => {
    try {
      const code = location.pathname.split("/")[2] || undefined;
      console.log(code);
      if (code === undefined) {
        // 코드가 없기때문에 잘못된 접근 이라고 하고 메인으로 넘긴다.?
        navigate("/");
        return;
      }
      params.current = trnasfromBase64ToObject(code);
      console.log(params.current);

      if (params.current.channelName === undefined) {
        // 코드가 없기때문에 잘못된 접근 이라고 하고 메인으로 넘긴다.?
        navigate("/");
      }

      updateLoaded(true);
    } catch (error) {
      alert(t("contact", "external.invalidCode"));
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (
      !bodyRef.current ||
      !section1.current ||
      !section2.current ||
      !section3.current ||
      !section4.current ||
      !section5.current ||
      !section6.current ||
      !section7.current ||
      !section8.current
    ) {
      return;
    }
    // let scrollTop = bodyRef.current.offsetTop - (mode === "Mobile" ? 60 : 80);
    let scrollTop = mode === "Mobile" ? -60 : -80;
    switch (true) {
      case ceoNameError || companyNameError:
        scrollTop += section1.current.offsetTop;
        window.scrollTo({ top: scrollTop, behavior: "smooth" });
        break;
      case ceoTelError || ceoEmailError:
        scrollTop += section2.current.offsetTop;
        window.scrollTo({ top: scrollTop, behavior: "smooth" });
        break;
      case descriptionError:
        scrollTop += section3.current.offsetTop;
        window.scrollTo({ top: scrollTop, behavior: "smooth" });
        break;
      case pfIndustrialTechError:
        scrollTop += section4.current.offsetTop;
        window.scrollTo({ top: scrollTop, behavior: "smooth" });
        break;
      case problemError:
        scrollTop += section5.current.offsetTop;
        window.scrollTo({ top: scrollTop, behavior: "smooth" });
        break;
      case solutionError:
        scrollTop += section6.current.offsetTop;
        window.scrollTo({ top: scrollTop, behavior: "smooth" });
        break;
      case fileError:
        scrollTop += section7.current.offsetTop;
        window.scrollTo({ top: scrollTop, behavior: "smooth" });
        break;
      case checkedError:
        scrollTop += section8.current.offsetTop;
        window.scrollTo({ top: scrollTop, behavior: "smooth" });
        break;
      default: {
        console.log("");
      }
    }
  }, [validationChecked]);

  useLayoutEffect(() => {
    updateTitle(t("contact", "external.pageTitle"));
  }, []);

  if (!loaded) return null;

  return (
    <Container>
      <ExternalNavigation>
        <div className="limit__body ">
          <Link to="/">{mode === "Mobile" ? <MNewLogo /> : <NewLogo />}</Link>
        </div>
      </ExternalNavigation>
      <ApplyBodyContainer className="limit__body" ref={bodyRef}>
        {mode === "Mobile" ? (
          <p className="font-body1">
            {renderText(t("contact", "external.heroMobile"))}
          </p>
        ) : (
          <p className="font-body">
            {renderText(t("contact", "external.heroDesktop"))}
          </p>
        )}

        <ApplySection style={{ marginTop: mode === "Mobile" ? 80 : 100 }}>
          <div className="section__title__container">
            <span
              className={`section__title ${
                mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
              }`}
            >
              {t("contact", "external.basicInfo")}
            </span>
            <span
              className={`section__description ${
                mode === "Mobile" ? "font-body4" : "font-body3"
              }`}
            >
              {t("contact", "external.basicInfoDesc")}
            </span>
          </div>
          <div className="section__row" ref={section1}>
            <ContactInput
              className="section__flex2"
              label={t("contact", "external.name")}
              inputType="text"
              placeHolder={t("contact", "external.namePlaceholder")}
              isError={ceoNameError}
              defaultValue={ceoName}
              onFocus={() => updateCeoNameError(false)}
              onChangeValue={(value) => updateCeoName(value)}
            />
            <ContactInput
              className="section__flex4"
              label={t("contact", "external.companyName")}
              inputType="text"
              placeHolder={t("contact", "external.companyNamePlaceholder")}
              isError={companyNameError}
              defaultValue={companyName}
              onFocus={() => updateCompanyNameError(false)}
              onChangeValue={(value) => updateCompanyName(value)}
            />
          </div>
          <div className="section__row" ref={section2}>
            <ContactInput
              className="section__flex2"
              label={t("contact", "external.phone")}
              inputType="phone"
              placeHolder={t("contact", "external.phonePlaceholder")}
              isError={ceoTelError}
              defaultValue={ceoTel}
              onFocus={() => updateCeoTelError(false)}
              onChangeValue={(value) => updateCeoTel(value)}
            />
            <ContactInput
              className="section__flex4"
              label={t("contact", "external.email")}
              inputType="text"
              placeHolder={t("contact", "external.emailPlaceholder")}
              isError={ceoEmailError}
              defaultValue={ceoEmail}
              onFocus={() => updateCeoEmailError(false)}
              onChangeValue={(value) => updateCeoEmail(value)}
            />
          </div>
          <div className="section__row" ref={section3}>
            <ContactTextArea
              label={t("contact", "external.itemSummary")}
              maxLength={500}
              isError={descriptionError}
              defaultValue={description}
              onFocus={() => updateDescriptionError(false)}
              onChangeValue={(value) => updateDescription(value)}
            />
          </div>
        </ApplySection>

        <ApplySection style={{ marginTop: mode === "Mobile" ? 40 : 100 }}>
          <div className="section__title__container">
            <span
              className={`section__title ${
                mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
              }`}
            >
              {t("contact", "external.sectorTitle")}
            </span>
          </div>
          <div className="section__row" ref={section4}>
            <SectorList
              isError={pfIndustrialTechError}
              defaultValue={pfIndustrialTech.map(
                (item) => item.acIndustrialTech
              )}
              onChange={(value) => {
                const sector = value.map((item, index) => {
                  return {
                    isMain: index === 0,
                    acIndustrialTech: {
                      acIndustrialTechId: item.acIndustrialTechId,
                      name: item.name,
                    },
                  };
                });
                updatePfIndustrialTechError(false);
                updatePfIndustrialTech(sector);
              }}
            />
          </div>
        </ApplySection>

        <ApplySection style={{ marginTop: 40 }}>
          <div className="section__title__container">
            <span
              className={`section__title ${
                mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
              }`}
            >
              {t("contact", "external.detailTitle")}
            </span>
            <span
              className={`section__description ${
                mode === "Mobile" ? "font-body4" : "font-body3"
              }`}
            >
              {t("contact", "external.detailDesc")}
            </span>
          </div>
          <div className="section__row" ref={section5}>
            <ContactTextArea
              label={t("contact", "external.problemLabel")}
              maxLength={500}
              isError={problemError}
              defaultValue={problem}
              onFocus={() => updateProblemError(false)}
              onChangeValue={(value) => {
                updateProblem(value);
              }}
            />
          </div>
          <div className="section__row" ref={section6}>
            <ContactTextArea
              label={t("contact", "external.solutionLabel")}
              maxLength={500}
              isError={solutionError}
              defaultValue={solution}
              onFocus={() => updateSolutionError(false)}
              onChangeValue={(value) => {
                updateSolution(value);
              }}
            />
          </div>
        </ApplySection>

        <ApplySection style={{ marginTop: mode === "Mobile" ? 40 : 100 }}>
          <div className="section__title__container">
            <span
              className={`section__title ${
                mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
              }`}
            >
              {t("contact", "external.businessPlan")}
            </span>
            <span
              className={`section__description ${
                mode === "Mobile" ? "font-body4" : "font-body3"
              }`}
            >
              {t("contact", "external.businessPlanDesc")}
            </span>
          </div>
          <div className="section__row" ref={section7}>
            <ContactFileUpload
              editable
              width={776}
              isError={fileError}
              defaultValue={file}
              onChangeFile={(file) => {
                updateFile(file);
                updateFileError(false);
              }}
            />
          </div>
        </ApplySection>

        <ApplySection style={{ marginTop: mode === "Mobile" ? 40 : 100 }}>
          <div className="section__title__container">
            <span
              className={`section__title ${
                mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
              }`}
            >
              {t("contact", "external.additionalInfo")}
            </span>
            <span
              className={`section__description ${
                mode === "Mobile" ? "font-body4" : "font-body3"
              }`}
            >
              {t("contact", "external.additionalInfoDesc")}
            </span>
          </div>
          <div className="section__row" ref={section8}>
            <ContactTextArea
              maxLength={500}
              defaultValue={additionalInformation}
              onChangeValue={(value) => updateAdditionalInformation(value)}
            />
          </div>
        </ApplySection>
        <div ref={section8}>
          <PrivacyPolicyCheckBox
            defaultCheck={checked}
            style={{ marginTop: 30 }}
            isError={checkedError}
            onChangeValue={(value) => {
              updateChecked(value);
              updateCheckedError(false);
            }}
          />
        </div>
        <SubmitButtonContainer>
          <DefaultButton
            className="font-sub-title4"
            type="submit"
            onClick={sendPortfolioInfo}
            width={194}
            height={60}
          >
            {t("contact", "external.submit")}
          </DefaultButton>
        </SubmitButtonContainer>

        <ModalLayout
          isOpen={isSuccessApplyModal}
          borderRadius={0}
          toggle={() => updateSuccessApplyModal(false)}
        >
          <SuccessApplyModal
            close={() => {
              updateSuccessApplyModal(false);
            }}
          />
        </ModalLayout>
        <ModalLayout isOpen={isProgress} borderRadius={0} isProgress>
          <Spinner loading={isProgress} size={80} />
        </ModalLayout>
      </ApplyBodyContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding-top: 68px;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
  }
`;
const ApplyBodyContainer = styled.div`
  flex-grow: 1;
  width: 100%;
  display: flex;
  padding-top: 100px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;

  .qna {
    cursor: pointer;
    .qna__arrow {
      transform: rotate(-45deg);
      path {
        fill: var(--primary);
      }
    }
  }

  .is__error {
    animation: shake 300ms;
  }
  @media only screen and (max-width: 768px) {
    padding-top: 40px;
    padding-bottom: 40px;
    .news__list {
      margin-top: 40px;
    }
  }
`;

const ApplySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  .section__title__container {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: flex-end;

    border-bottom: 1px solid var(--grey-00);
    padding-bottom: 16px;

    .section__title {
      color: var(--grey-60);
    }

    .section__description {
      padding-bottom: 6px;
      color: var(--grey-30);
    }
  }

  .section__row {
    display: flex;
    flex-direction: row;
    gap: 24px;

    .section__flex1 {
      flex: 1;
    }
    .section__flex2 {
      flex: 2;
    }
    .section__flex3 {
      flex: 3;
    }
    .section__flex4 {
      flex: 4;
    }
  }

  @media only screen and (max-width: 768px) {
    .section__title__container {
      flex-direction: column;
      align-items: flex-start;
      gap: 0px;
    }

    .section__row {
      flex-direction: column;
      gap: 40px;
    }
  }
`;
const CheckBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;
const SubmitButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 160px;

  @media only screen and (max-width: 768px) {
    align-items: center;
    justify-content: center;
    margin-top: 80px;
  }
`;

const ExternalNavigation = styled.div`
  position: fixed;
  width: 100vw;
  min-height: 68px;
  top: 0px;
  left: 0px;
  background-color: #fbfbfb;
  z-index: 10;

  .external__navigation__container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
export default ExternalApply;
